import { Logger, MapND } from "@kosmod/kit";

import { Observable, Subject } from 'rxjs';
import { ChunkKey } from "./chunk";

export type ChunkAction = 'add' | 'update' | 'remove';

/**
 * Coordinates updates across chunks, allowing various
 * canvases to express themselves as dependencies
 * of other canvases
 */
export type CanvasCoordinator = {
  run(): void,
  queue(actions: [ChunkKey, ChunkAction]): void,
  queueMany(actions: Iterable<[ChunkKey, ChunkAction]>): void,
  updates: Observable<[ChunkKey, ChunkAction][]>
}

export const createCanvasUpdateCoordinator = (
  logger: Logger,
) => {
  let queue = new MapND<ChunkKey, ChunkAction>();
  let running = false;

  const subject = new Subject<[ChunkKey, ChunkAction][]>();

  return {
    /**
     * Start updating canvases. Since some canvases depend on updates
     * to others, this function may repeat/recurse a few times.
     */
    run() {
      if (running)
        return;
      
      let rounds = 0;
      running = true;
      while (queue.size > 0) {
        rounds++;
        const current = [...queue.entries()];
        logger.log(`CanvasUpdate`, current.map(c => c[0]))
        queue = new MapND();
        subject.next(current);
      }
      running = false;
      logger.log(`Completed CanvasUpdate in ${rounds} rounds`);
    },
    queue(action: [ChunkKey, ChunkAction]) {
      queue.set(action[0], action[1])
      // if (!running)
      //   this.run();
    },
    queueMany(actions: Iterable<[ChunkKey, ChunkAction]>) {
      for (const action of actions) {
        queue.set(action[0], action[1])
      }
    },
    updates: subject.asObservable()
  }
};
